<template>
  <section>
    <el-dialog
      v-dialogDrag
      :title="title"
      :visible="dialogFormVisible"
      @close="cancelForm"
      :close-on-click-modal="false"
      class="el-dialog-double"
    >
      <el-form
        label-width="300px"
        :model="formList"
        :rules="rules"
        ref="ruleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="要授权的员工：" prop="">
              
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="cancelForm()">取 消</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
export default {
  props: ["showdialog"],
  watch: {
    showdialog() {
      this.dialogFormVisible = this.showdialog;
    },
  },
  components: {},
  data() {
    return {
      title: "设置上级",
      dialogFormVisible: this.showdialog,
      OperType: 0, //0 新增  1修改
      formList: {},      
      rules: {
        // employeeId: [{required: true, message: "请选择用户", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    cancelForm() {
      //取消关闭
      this.$emit("update:showdialog", false);
      this.$nextTick(function() {
        this.$refs.ruleForm.resetFields(); //重置输入框提示
      });
    },
  },
};
</script>
<style lang="scss"></style>
